import React from "react";
import { Chip } from "@mui/material";
import { BADGE_COLORS, getBadgeStyles } from "./badgeColors";
import { ORIGENES } from "../../constants";

/**
 * Badge para orígenes de incidencias.
 * El origen es un metadato categórico: cada origen tiene un color distinto solo
 * para identificarlo visualmente (no implica estado bueno/malo).
 */
const OrigenBadge = ({ origen, label }) => {
  const getColorByOrigen = (origen) => {
    switch (origen) {
      case ORIGENES.STICKER:
        return BADGE_COLORS.BLUE; // Etiqueta
      case ORIGENES.SALES:
        return BADGE_COLORS.GREEN; // Ventas
      case ORIGENES.PURCHASES:
        return BADGE_COLORS.AMBER; // Compras
      case ORIGENES.INVENTARIO:
        return BADGE_COLORS.GRAY; // Inventario
      case ORIGENES.ORDER:
        return BADGE_COLORS.RED; // Pedido
      case ORIGENES.NAVE2:
        return BADGE_COLORS.TEAL; // Nave 2
      default:
        return BADGE_COLORS.GRAY;
    }
  };

  return (
    <Chip
      label={label}
      size="small"
      sx={getBadgeStyles(getColorByOrigen(origen))}
    />
  );
};

export default OrigenBadge;
